<template>
  <div>
    <back-button route='/LopendeOrders'>Alle lopende orders</back-button>

    <div class="md-layout md-gutter md-alignment-top-center">

      <prop-card class="md-layout-item" :data="itemVm" :header="item != null ? item.No : ''" />

      <md-table v-if="item != null && item.Lines.length > 0" v-model="item.Lines" class="md-layout-item" md-card>
        <md-table-toolbar>
          <h1 class="md-title">Orderregels</h1>
        </md-table-toolbar>

        <md-table-row slot="md-table-row" slot-scope="{ item }">
          <md-table-cell md-label="Nr.">{{ item.No }}</md-table-cell>
          <md-table-cell md-label="Omschrijving">{{ item.Description }}</md-table-cell>
          <md-table-cell md-label="Aantal">{{ item.Quantity }}</md-table-cell>
          <md-table-cell md-label="Eenheidscode">{{ item.Unit_of_Measure_Code }}</md-table-cell>
          <md-table-cell md-label="Verzonden aantal">{{ item.Quantity_Shipped }}</md-table-cell>
          <md-table-cell md-label="Gefactureerd aantal">{{ item.Quantity_Invoiced }}</md-table-cell>
          <md-table-cell md-label="Openstaand aantal">{{ item.Quantity && item.Quantity_Shipped ? item.Quantity - item.Quantity_Shipped : '' }}</md-table-cell>
        </md-table-row>
      </md-table>
    </div>
  </div>
</template>

<script>
  import Api from '@/api';
  import { Events } from '@wsb/wsb-jsbase';
  import PC from '@/components/PropCard';
  import BB from '@/components/BackButton';
  import Format from '@/format';

  export default {
    name: 'LopendeOrder',
    props: ['id'],
    created: function() {
      this.item.Nr = this.id;
    },
    data: () => ({
      item: null
    }),
    computed: {
      itemVm: function () {
        if (this.item !== null) {
          var obj = {
            'Nr.': this.item.No,
            'Factuuradres': `${this.item.Bill_to_Name}\n${this.item.Bill_to_Address}\n${this.item.Bill_to_Post_Code}, ${this.item.Bill_to_City}`,
            'Orderdatum': Format.date(this.item.Posting_Date)
          };
          const verz = `${this.item.Ship_to_Name}\n${this.item.Ship_to_Address}\n${this.item.Ship_to_Post_Code}, ${this.item.Ship_to_City}`;
          if (verz != obj['Factuuradres']) {
            obj['Verzendadres'] = verz;
          }

/////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////////////
////////////////////
          if (this.item.External_Document_No != '') { obj['Extern documentnr.'] = this.item.External_Document_No; }
          return obj;
        } else {
          return null;
        }
      }
    },
    methods: {
      load() {
        Api.Get(`/odata/SalesOrder('${this.id}')?$expand=Lines`, ['Order_Date', 'Posting_Date', 'Shipment_Date'])
          .then(r => {
            r.Lines = r.Lines.map(i => i.No !== '' ? i : { Description: i.Description });
            this.item = r;
          })
          .catch(Events.RaiseExceptionOccurred);
      }
    },
    created() {
      this.load();
    },
    components: {
      'prop-card': PC,
      'back-button': BB
    }
  };
</script>

<style scoped>
  td {
    padding: 4pt;
  }
  .tdMain {
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/LopendeOrder.vue